import { Send, ArrowUpRight } from "lucide-react";
import { T } from "@/constants/testIds";
import { LINKS, CONTRACT, ASSETS } from "@/constants/links";
import XIcon from "@/components/XIcon";

const OUT = [
  [LINKS.telegram, "Telegram", T.footerTelegram, <Send size={14} />],
  [LINKS.twitter, "X / Twitter", T.footerTwitter, <XIcon size={13} />],
  [LINKS.uniswap, "Buy on Uniswap", T.footerUniswap, <ArrowUpRight size={14} />],
  [LINKS.dexscreener, "DexScreener", T.footerDex, <ArrowUpRight size={14} />],
  [LINKS.explorer, "Blockscout", T.footerExplorer, <ArrowUpRight size={14} />],
];

export default function Footer() {
  return (
    <footer className="relative bg-ink text-paper pt-16 md:pt-24 pb-10 overflow-hidden" data-testid={T.footer}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img src={ASSETS.logo} alt="DIH" className="w-16 h-16 rounded-2xl object-cover border-2 border-[color:var(--lime)]" />
              <div>
                <div className="font-display text-xl uppercase">Dog in Hood</div>
                <div className="font-mono text-[11px] text-[color:var(--muted)] tracking-widest mt-1">$DIH · EST. 2026 · ROBINHOOD CHAIN</div>
              </div>
            </div>
            <p className="mt-6 text-base text-paper/60 max-w-md">
              Community-run. Hood-run. Not affiliated with Robinhood, Uniswap, or any dog that takes its hood off.
            </p>
            <div className="mt-6">
              <div className="kicker text-[color:var(--muted)] mb-2">Contract</div>
              <div data-testid={T.footerContract} className="font-mono text-xs text-lime break-all">{CONTRACT}</div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {OUT.map(([href, label, id, icon]) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noreferrer"
                data-testid={id}
                className="card p-5 flex items-center justify-between font-display text-sm uppercase hover:text-lime"
              >
                {label}
                {icon}
              </a>
            ))}
            <a
              href="#top"
              className="card p-5 flex items-center justify-between font-display text-sm uppercase hover:text-lime"
            >
              Back to top
              <span className="rotate-[-90deg] inline-block">→</span>
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-20 border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[11px] uppercase tracking-widest text-[color:var(--muted)]">
          <span>© 2026 Dog in Hood. Not financial advice. Financial hoodie.</span>
          <span>Burn data read onchain via RPC · market data via DexScreener</span>
        </div>
      </div>

      <div className="pointer-events-none select-none font-display uppercase text-lime leading-none text-[38vw] md:text-[30vw] text-center -mb-[0.28em] mt-6 opacity-95">
        DIH
      </div>
    </footer>
  );
}
